/**
 * Đơn vị hưởng
 */
export default {
  Organization: 1, //đơn vị
  Person: 2, //người hưởng
};
